import { MdOutlineDescription } from "react-icons/md";

const Simple = ({ element }) => {
  return (
    <div className="__file">
      <div>
        <div>
          <MdOutlineDescription size={20} />
          <span className="__file-name" title={element.filename}>
            {element.filename}
          </span>
          <span></span>
        </div>
      </div>
    </div>
  );
};

export default Simple;
